<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<span epub:type="pagebreak" id="p5" title="5">
<h1 class="toctitle"><span class="line_top">Contents</span></h1>
<p class="toc"><a href="#/html/p006#AA1">Make-It-Easy Freezer Meals</a></p>
<p class="toc_1">•••</p>
<p class="toc1">1 <a href="#/html/p010#AA2">Breakfast &amp; Brunch</a></p>
<p class="toc1">2 <span href="#/html/p054#AA3" title="Link target outside of Sample">Beef &amp; Pork</span></p>
<p class="toc1">3 <span href="#/html/p108#AA4" title="Link target outside of Sample">Chicken &amp; Turkey</span></p>
<p class="toc1">4 <span href="#/html/p162#AA5" title="Link target outside of Sample">Fish &amp; Seafood</span></p>
<p class="toc1">5 <span href="#/html/p192#AA6" title="Link target outside of Sample">Meatless</span></p>
<p class="toc1">6 <span href="#/html/p244#AA7" title="Link target outside of Sample">Desserts</span></p>
<p class="toc_1a">•••</p>
<p class="toc_2"><span href="#/html/p296#AA8" title="Link target outside of Sample">Metric Conversion Guide</span></p>
<p class="toc_2"><span href="#/html/p297#AA9" title="Link target outside of Sample">Index</span></p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p005.vue?ffea56a6